import styled from "styled-components";
import { Button } from "../../../services/visualLibraryService";

export const PlayerShadow = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  &::before {
    width: 100%;
    height: 100%;
    position: absolute;
    content: "";
    left: 0;
    background-color: rgba(26, 26, 28, 0.6);
    z-index: ${props => props.theme.zIndex.base};
  }
`;

export const PlayerShadowAds = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  &::before {
    width: 100%;
    height: 100%;
    position: absolute;
    content: "";
    left: 0;
    // background-color: rgba(26, 26, 28, 0.6);
    z-index: ${props => props.theme.zIndex.base};
  }
`;

export const ButtonSkipIntroStyled = styled(Button)`
  position: absolute;
  bottom: ${props => props.theme.baseLayoutPaddingBs + "%"};
  ${props => `${props.theme.locale.dir === "rtl" ? "right" : "left"}: ${props.theme.baseLayoutPaddingBs + "%"}`};
  // line-height: normal;
  // display: inline-flex;
  // align-items: center;
  // -webkit-justify-content: center;
  // text-align: center;
  line-height: 1.3;
  span {
    vertical-align: baseline;
  }
`;
